<!-- eslint-disable vue/no-bare-strings-in-template -->
<!--
  Root Error message. Similar to a kernel panic, displayed when things go wrong
  before the application router is loaded.
-->
<template>
  <DebugError v-if="error && showError">
    <template #title>Root Error</template>
    <p>An error has occurred:</p>
    <p>
      <code>{{ error }}</code>
    </p>
  </DebugError>
  <RootError v-else-if="error" />
  <div v-else-if="empty" />
  <slot v-else />
</template>

<script setup lang="ts">
import {computed, onErrorCaptured, ref} from 'vue';
import DebugError from '@/components/ui/DebugError/DebugError.vue';
import RootError from '@/components/ui/RootError/RootError.vue';
import {useEnvironmentStore} from '@/env/useEnvironmentStore';
import {featureEnabledInLocalStorage} from '@/utils/features';
import logToMonitor from '@/utils/logging';

const {environment} = useEnvironmentStore();

const error = ref();
const empty = ref(false);

onErrorCaptured((err: Error) => {
  error.value = err;

  // Exception for Data Provider / Auth to not display the thrown error when redirecting:
  if (err.error === 'login_required') {
    error.value = null;
    empty.value = true;
  }

  if (error.value) {
    logToMonitor(err, {
      _myparcel_boundary: 'Root',
      _myparcel_extra_info: 'Unhandled error captured by RootErrorBoundary',
      _myparcel_route: window.location?.pathname,
    });
  }

  // throw error to console in dev mode, otherwise not.
  return environment.devMode;
});

const showError = computed(() => {
  return environment.devMode || featureEnabledInLocalStorage('errors');
});
</script>
